export const LADE_KATEGORIEN = "ladeKategorien"
